import { SubclassType, WordEntityTypeWithParentKeys } from "../type";
import { genBlock } from "@/utils/bem";
import { Box, Flex, Popover, PopoverBody, PopoverContent, PopoverTrigger } from "@chakra-ui/react";
import { langStore } from "@noli/business";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";

import getScrollBarProps from "@/styles/scrollBarProps";
import { ExpandableText } from "../ExpandableText";
import { KeywordList } from "../KeywordList";
import "./style.scss";
import { WordTableContext } from "../context";

export const block = genBlock("c-word-table-subclass");
/**
 * 二级选择项
 * @returns
 */
const ISubclassCell: React.FC<{
  data: SubclassType<WordEntityTypeWithParentKeys>;
}> = ({ data }) => {
  const { nameDict } = useContext(WordTableContext);
  const [open, setOpen] = useState(false);
  const lang = langStore.tgt;

  return (
    <Box className={block({ e: "item-wrapper" })}>
      <Popover
        isLazy
        placement="right"
        boundary={document.body}
        matchWidth
        isOpen={open}
        onClose={() => setOpen(false)}
        // eventListeners={false}
        preventOverflow
        flip
        gutter={25}
        modifiers={[
          {
            name: "topLogger",
            enabled: true,
            phase: "main",
            fn: ({ state }) => {
              state.styles.popper.zIndex = "1000";
              return state;
            },
          },
        ]}
      >
        <PopoverTrigger>
          <ExpandableText
            open={open}
            onClick={() => setOpen((open) => !open)}
            lineHeight={1.3}
            p="6px 8px"
            whiteSpace="nowrap"
            minW="85px"
          >
            {nameDict[data.key]?.[lang]}
          </ExpandableText>
        </PopoverTrigger>
        <PopoverContent border="none" bg="#3A3A3A" rounded="12px" w="auto" zIndex={500}>
          <PopoverBody p="0px" w="fit-content">
            <KeywordList list={data.children} onClose={() => setOpen(false)} />
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
const SubclassCell = observer(ISubclassCell);

/**
 * 二级选择菜单
 * @returns
 */
const ISubclassMenu: React.FC<{
  list: SubclassType<WordEntityTypeWithParentKeys>[];
}> = ({ list }) => {
  return (
    <Flex
      maxH="50vh"
      {...getScrollBarProps({ autoMargin: false })}
      flexDir="column"
      className={block()}
      p="10px"
      bg="#3A3A3A"
      fontSize="sm"
      boxShadow="0px 0px 16px rgba(0, 0, 0, 0.25)"
    >
      {list.map((subclass) => (
        <SubclassCell data={subclass} key={subclass.key} />
      ))}
    </Flex>
  );
};
export const SubclassMenu = observer(ISubclassMenu);
